import React from 'react';
import HomeIcon from '@material-ui/icons/Home';
import EventIcon from '@material-ui/icons/Event';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import ChatIcon from '@material-ui/icons/Chat';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import DuoIcon from '@material-ui/icons/Duo';
import ExploreIcon from '@material-ui/icons/Explore';
import DateRangeIcon from '@material-ui/icons/DateRange';
import BackupIcon from '@material-ui/icons/Backup';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ListAltIcon from '@material-ui/icons/ListAlt';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';

export const SidebarData = [
	{
		title: 'Calendar',
		icon: <DateRangeIcon />,
		link: '/calendar',
		role: ['superadmin', 'admin'],
		canBeNull: false,
	},
	// {
	// 	title: 'My clients',
	// 	icon: <PermContactCalendarIcon />,
	// 	link: '/clients',
	// 	role: ['superadmin', 'admin'],
	// 	canBeNull: false,
	// },
	{
		title: '3D Virtual Hub',
		icon: <HomeWorkIcon />,
		link: '/3dhomes',
		role: ['superadmin', 'admin'],
		canBeNull: true,
	},
	// {
	// 	title: 'Site Plan',
	// 	icon: <ExploreIcon />,
	// 	link: '/siteplan',
	// 	role: ['superadmin', 'admin'],
	// 	canBeNull: true,
	// },
	// {
	// 	title: 'File Explorer',
	// 	icon: <BackupIcon />,
	// 	link: '/fileexplorer',
	// 	role: ['superadmin', 'admin'],
	// 	canBeNull: true,
	// },
	// {
	// 	title: 'Finances',
	// 	icon: <AttachMoneyIcon />,
	// 	link: '/finance',
	// 	role: ['superadmin', 'admin'],
	// 	canBeNull: true,
	// },
	// {
	// 	title: 'Box Matrix',
	// 	icon: <ListAltIcon />,
	// 	link: '/box-matrix',
	// 	role: ['superadmin', 'admin'],
	// 	canBeNull: true,
	// },
	// 	{
	// 		title: 'Book Appointment',
	// 		icon: <MeetingRoomIcon />,
	// 		link: '/book-appointment',
	// 		role: ['client'],
	// 		canBeNull: true,
	// 	},
];
